export default __webpack_public_path__ + "static/media/LINE_spinner_dark.3f1c87a9.svg";